module.exports = __webpack_public_path__ + "malaysia.svg?741d5adeae1d6307023d3e5ad88b4cdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/malaysia.svg
// module id = 222
// module chunks = 10